import axios from 'axios';
import { Button, Row, Col, Upload } from 'antd'
import _ from 'lodash'
import moment from 'moment'
import Papa from 'papaparse'
import { useEffect, useState } from 'react'
import { db, firestore, auth } from '../../firebase'
import { LeadShareParterModal } from '../modals/leadSharePartnerModal'

const TestZone = () => {

  const uploadSuppression = async records => {

    // Firestore batch limit
    const batchSize = 500
    let batch = firestore.batch()
    let counter = 0

    for (let record of records) {

      batch.set(firestore.collection('marketBeatLeadShare').doc(record[0]), {
        email: record[0],
        send_order: Number(record[1])
      })

      counter++

      // Commit each batch
      if (counter === batchSize) {

        await batch.commit()
        batch = firestore.batch()
        counter = 0

        console.log('Batch committed')

        // 1000 ms delay
        await new Promise(resolve => setTimeout(resolve, 1000))
      }
    }

    // Commit the last batch if it has less than 500 writes
    if (counter > 0) {

      await batch.commit()
      console.log('Final batch committed')
    }

    console.log('Upload complete')
  }

  const uploadData = async records => {

    for (let [index, record] of records.entries()) {

      const email = record[0]
      const offer = record[1]
      const partner = record[2]

      try {

        // Make individual request for each record
        const url = `https://us-central1-btm-dashboard-5a1e2.cloudfunctions.net/capture?email=${email}&offer=${offer}&affId=${partner}`
        const response = await axios.post(url)

        console.log('Processed:', response, email, offer, partner)

      } catch (error) {

        console.error('Error:', error, email, offer, partner)
      }

      await new Promise(resolve => setTimeout(resolve, 500))
    }

    console.log('All records processed')
  }

  const updateMailChimp = async records => {

    for (let [index, record] of records.entries()) {

      const email = record[0]

      try {

        // Make individual request for each record
        const url = `https://us-central1-btm-dashboard-5a1e2.cloudfunctions.net/updateMailChimp?email=${email}&listId=f0ce560449`
        const response = await axios.post(url)

        console.log('Record processed successfully:', index, email, response.status)

      } catch (error) {

        console.error('Error processing record:', index, email, error)
      }

      await new Promise(resolve => setTimeout(resolve, 500))
    }

    console.log('All records processed')
  }

  const uploadBlockedNames = async () => {

    const blockListEmails = []

    const batchSize = 100; // Firestore batch size limit
    const numBatches = Math.ceil(blockListEmails.length / batchSize);

    for (let i = 0; i < numBatches; i++) {
      const batch = firestore.batch();
      const start = i * batchSize;
      const end = start + batchSize;

      blockListEmails.slice(start, end).forEach((email, idx) => {
        const docRef = firestore.collection('blockEmail').doc(); // or use email as doc ID if unique
        batch.set(docRef, { value: email.toLowerCase(), created: db.firestore.FieldValue.serverTimestamp() });
      });

      // Commit the batch
      batch.commit().then(() => {
        console.log(`Batch ${i + 1} committed.`);
      }).catch((error) => {
        console.error(`Error committing batch ${i + 1}:`, error);
      });

      // Optional: Add a small delay between batches to avoid rate limiting
      if (i < numBatches - 1) {
        await new Promise(resolve => setTimeout(resolve, 500)); // 500ms delay
      }
    }
  }

  const uploadSuppressionList = async () => {
    const listName = 'TODO LIST NAME HERE'
    console.log('uploadSuppressionList', listName)

    const res = await firestore.collection(listName).get()

    if (!res.empty) {
      alert(`Suppression ${listName} list exists already: aborting`)
      return
    }

    const suppressionList = [
      'c4e48341a5b7341e02b8b0d95dd08f55', // suppressed@desmat.ca
      
      // LIST GOES HERE
    ]

    const batchSize = 100; // Firestore batch size limit
    const numBatches = Math.ceil(suppressionList.length / batchSize);
    let total = 0;

    for (let i = 0; i < numBatches; i++) {
      const batch = firestore.batch();
      const start = i * batchSize;
      const end = start + batchSize;

      suppressionList.slice(start, end).forEach((email, idx) => {
        const docRef = firestore.collection(listName).doc(email); // or use email as doc ID if unique
        batch.set(docRef, { exists: true, created_at: db.firestore.FieldValue.serverTimestamp() });
        total++;
      });

      // Commit the batch
      batch.commit().then(() => {
        console.log(`Batch ${i + 1}/${numBatches} committed.`);
      }).catch((error) => {
        console.error(`Error committing batch ${i + 1}:`, error);
      });

      // Optional: Add a small delay between batches to avoid rate limiting
      if (i < numBatches - 1) {
        await new Promise(resolve => setTimeout(resolve, 10));
      }
    }

    console.log(`Committed ${total} total.`);
  }

  const props = {
    customRequest: (e) => {
      console.log({ e })
      Papa.parse(e.file, {
        complete: async (results, file) => {

          console.log("Parsing complete:", results.data)
          uploadData(results.data)
        }
      })
    }
  }

  const handleLiveDataUpload = async () => {

    const mbRes = await firestore.collection('marketBeatLeadShare')
      .orderBy('send_order', 'asc')
      .limit(10)
      .get()

    const mbData = mbRes.docs.map(x => ({ ...x.data(), id: x.id }))

    console.log(mbData)
  }

  const sendVerificationEmail = async () => {
    await auth.currentUser.sendEmailVerification()
  }

  const testLeadSharePartner = {
    "status": "active",
    "send_headers": {
      "Authorization": "$secrets.ALTA_SECRET",
      "content-type": "application/json"
    },
    "expect_response_data_matches": "success",
    "total_count": 1200,
    "share_to": "Alta - Sovereign Wealth Fund",
    "count": 300,
    "send_data": "[{\"brandId\":\"6001\",\"pubCode\":\"LNEL\",\"campaignId\":\"MKT840300\",\"source\":\"MKT840971\",\"email\":\"$lead.email\",\"emailTemplateUrl\":\"https://marketingassets.marketwise.com/prod/common/LNEL/ConfirmationEmail/1749240293320.html\",\"emailSubject\":\"Your Free Report: 3 Stocks for Trump's New Industrial Boom\",\"externalChannel\":\"{{siteId}}\",\"authOptIn\":false}]",
    "name": "Alta - Sovereign Wealth Fund",
    "send_method": "POST",
    "max_daily": 300,
    "send_url": "https://webhook.site/1a51b6e0-2ca6-40c9-8935-cbe348407d02?email=$lead.email",
    // mock firestore timestamp
    "last_timestamp": {
      toDate() {
        return Date();
      }
    },
    "id": "altaSovereign",
    "include_lead_function": 'myCustomIncludeLeads', // NOTE that this is multially exclusive to the includeX/excludeX fields
    // "include_any_lead": ['*'],
    "include_any_lead": ['lead: mb', 'lead: rejected', 'domain: yahoo'],
    "include_all_lead": ['affId: 271', 'affId: 346', 'affId: sa', 'affId: 148', 'affId: 124', 'affId: NOPE'],
    "exclude_any_lead": ['max daily exceeded', 'lead: dupe'], // THIS WOULD BE PRETTY MUCH STANDARD TO ALL
    "exclude_all_lead": ['list: DIT', 'list: DMA', 'list: MMT',],
    "suppression_list": "theSuppressionList",
    "backfill": {
      "backfill_1": true,
      "backfill_2": false,
    }
  }

  const newLeadSharePartner = {
    "status": "paused",
    "total_count": 0,
    "count": 0,
    "last_timestamp": moment().set("hour", 6).set("minute", 0).set('second', 0).set('millisecond', 0),
    "include_any_lead": ['*'],
  }

  const [partner, setPartner] = useState();
  const [onLeadShareModalSaved, setOnLeadShareModalSaved] = useState(() => undefined)

  const testLeadShareModal = () => {
    setOnLeadShareModalSaved(() => (data) => {
      alert(JSON.stringify(data, undefined, ' '));
      setPartner(undefined)
    })
    setPartner(testLeadSharePartner)
  }

  const createNewLeadShare = () => {
    setOnLeadShareModalSaved(() => async (data) => {
      // console.log("createNewLeadShare", { data })

      const partnerId = _.camelCase(data.name)
      const doc = firestore.collection('altaSend').doc(partnerId)
      const res = await doc.get()

      console.log("createNewLeadShare", { partnerId, res, empty: res.exists })

      if (res.exists) throw Error(`A leadShare with id ${partnerId} (derived from name) already exists: pick another name`)

      const { id, ...cleanedData } = data
      await doc.set({
        ...cleanedData,
      })

      setPartner(undefined)
    })
    setPartner(newLeadSharePartner)
  }

  const touchDocuments = async () => {
    const dry_run = true
    const from_date = '2025-09-01'
    const to_date = '2026-01-01'
    const shared_to = undefined // 'Daily Market Alert'
    const collection = 'TODO'

    let query = firestore.collection(collection)

    if (shared_to) query = query.where('shared_to', '==', shared_to)

    if (from_date) {
      // expect yyyy-mm-dd
      const parsed = new db.firestore.Timestamp(new Date(from_date).getTime() / 1000, 0)
      query = query.where('created_at', '>=', parsed)
    }

    if (to_date) {
      // expect yyyy-mm-dd
      const m = moment(to_date).add(+1, 'day')
      const parsed = new db.firestore.Timestamp(m.valueOf() / 1000, 0)
      query = query.where('created_at', '<', parsed)
    }

    const res = await query.get()

    const batchSize = 500
    const numBatches = Math.ceil(res.docs.length / batchSize)
    const updated = []

    console.log('touchDocuments', { data_length: res.docs.length })

    for (let batchNum = 0; batchNum < numBatches; batchNum++) {
      console.log('touchDocuments', { batchSize, numBatches, batch: batchNum })
      const batch = firestore.batch()

      for (let doc of res.docs.slice(batchNum * batchSize, (batchNum + 1) * batchSize)) {
        const data = doc.data()
        const update = { touched_at: db.firestore.FieldValue.serverTimestamp() }
        // const update = {};

        if (!dry_run && Object.keys(update).length > 0) {
          batch.update(doc.ref, update);
        }

        // updated.push({ ...data, ...update })
      }

      // eslint-disable-next-line no-await-in-loop
      await batch.commit()
    }

    console.log('touchDocuments', { updated })
  }

  return (
    <>
      {partner &&
        <LeadShareParterModal partner={partner} onCancel={() => setPartner(undefined)} onOk={onLeadShareModalSaved} />
      }

      <Row justify='space-evenly' align='middle' gutter={[8, 16]}>
        <Col>
          <Upload {...props}>
            <Button>CSV DATA</Button>
          </Upload>
        </Col>
        <Col >
          <Button onClick={uploadBlockedNames}>DO IT LIVE</Button>
        </Col>
        <Col>
          <Button onClick={testLeadShareModal}>LEADSHARE MODAL</Button>
        </Col>
        <Col>
          <Button onClick={createNewLeadShare}>NEW LEADSHARE</Button>
        </Col>
        <Col>
          <Button onClick={sendVerificationEmail}>SEND VERIFICATION EMAIL</Button>
        </Col>
        <Col>
          <Button onClick={uploadSuppressionList}>UPLOAD SUPPRESSION LIST</Button>
        </Col>
        <Col>
          <Button onClick={touchDocuments}>TOUCH DOCUMENTS (not like that you perv!)</Button>
        </Col>
      </Row>
    </>
  )
}

export default TestZone